import React from 'react';
import 'semantic-ui-css/semantic.min.css'
import ReactDOM from 'react-dom/client';
import './index.css';
import Read from './components/read';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Loader from './components/Loader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
